import type { FieldDefinition, Meta } from '@numistic/contracts'
import { formatPlain, type RefResolver } from '@numistic/domain'

import { formatMoney } from '../lib/format.js'

/** Значение поля для показа человеку: с единицей измерения и названиями из справочников. */
export function displayValue(
  meta: Meta,
  def: FieldDefinition,
  value: unknown,
  resolveRef: RefResolver,
): string {
  if (def.dataType === 'grade' && value && typeof value === 'object') {
    const g = value as { scale: string; value: string }
    const name = meta.gradeScales
      .find((s) => s.code === g.scale)
      ?.values.find((v) => v.code === g.value)?.name.ru
    return name ?? g.value
  }
  if (def.dataType === 'money' && value && typeof value === 'object') {
    const m = value as { amount: string; currency: string }
    return formatMoney(m.amount, m.currency)
  }
  const text = formatPlain(meta, def, value, resolveRef)
  return text && def.unit ? `${text} ${def.unit}` : text
}
